
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/workday-adaptive-planning",
      function () {
        return require("private-next-pages/destinations/workday-adaptive-planning.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/workday-adaptive-planning"])
      });
    }
  